var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-out-box"},[_c('router-view',{staticClass:"main-box"}),_c('v-footer',{on:{"toAbout":_vm.toLocal}}),_c('v-asidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }